import { describeFields } from '../common/fields';
import { LegacyTopicSchema } from './schemas';

export const LEGACY_TOPIC_FIELDS = describeFields(LegacyTopicSchema, {
  id: {},
  subject: {},
  code: {},
  label: {},
  topicGroupId: {},
  topicGroupCode: {},
});
